// extracted by mini-css-extract-plugin
export default {"cls1":"VeloRadioImage-RadioImageContainer_cls1__8bDMj","cls2":"VeloRadioImage-RadioImageContainer_cls2__tghoi VeloRadioImage-RadioImageContainer_cls1__8bDMj"};